/** The one public origin. Canonicals, hreflang, sitemap and JSON-LD always point here. */
export const PRODUCTION_ORIGIN = "https://zettl.cz";

/**
 * Canonical site origin for absolute SEO/social URLs.
 *
 * Deliberately not `window.location.origin`: previews (`pr-<N>.zettlapp.com`,
 * `*.vercel.app`) must keep their canonical on zettl.cz so they never
 * compete with production. `VITE_PUBLIC_SITE_URL` overrides it (e.g. a
 * self-hosted copy).
 */
export function getSiteOrigin(): string {
  return normalizeOrigin(import.meta.env.VITE_PUBLIC_SITE_URL) ?? PRODUCTION_ORIGIN;
}

export function normalizeOrigin(value: unknown): string | null {
  if (typeof value !== "string") return null;
  const trimmed = value.trim().replace(/\/+$/, "");
  return /^https?:\/\/[^/\s]+$/.test(trimmed) ? trimmed : null;
}

/**
 * Whether this deployment may be indexed: only Vercel production.
 * Previews, local builds and CI answer `Disallow: /` and `noindex`.
 */
export function isIndexableDeployment(vercelEnv: string | undefined): boolean {
  return vercelEnv === "production";
}
